import {
  TreePropertyType,
  type MeasurementTypeTreePropertyDescriptor,
  type RemoveOrPruneTreePropertyDescriptor,
  type SizeEstimateTreePropertyDescriptor,
  type TreeDescriptor,
  type TrunkTypeTreePropertyDescriptor,
} from "@/components/treeModule";

export function isTreeItemValid(treeDescriptor: TreeDescriptor) {
  return Array.from(treeDescriptor.properties.values()).every((property) => {
    const measurementType = treeDescriptor.properties.get(
      TreePropertyType.measurement_type,
    ) as MeasurementTypeTreePropertyDescriptor | undefined;

    const trunkType = treeDescriptor.properties.get(
      TreePropertyType.trunk_type,
    ) as TrunkTypeTreePropertyDescriptor | undefined;

    // if location is off site, description is required
    if (
      property.propertyType === TreePropertyType.location &&
      property.value === "off site" &&
      !property.description
    ) {
      return false;
    }

    // if measurement type is detailed, size is not required
    if (
      property.propertyType === TreePropertyType.size &&
      measurementType?.value === "detailed"
    ) {
      return true;
    }

    // if remove or prune is remove, pruning quantity is not required
    if (property.propertyType === TreePropertyType.pruning_quantity) {
      const removeOrPrune = treeDescriptor.properties.get(
        TreePropertyType.remove_or_prune,
      ) as RemoveOrPruneTreePropertyDescriptor | undefined;

      if (!removeOrPrune?.value || removeOrPrune.value === "remove") {
        return true;
      }
    }

    // if measurement type is estimate, dbh and circumference are not required
    if (
      (property.propertyType === TreePropertyType.dbh ||
        property.propertyType === TreePropertyType.circumference) &&
      measurementType?.value === "estimate"
    ) {
      return true;
    }

    // if trunk type is vegetation, dbh, height and circumference are not required
    if (
      (property.propertyType === TreePropertyType.dbh ||
        property.propertyType === TreePropertyType.circumference ||
        property.propertyType === TreePropertyType.height) &&
      trunkType?.value === "vegetation"
    ) {
      return true;
    }

    // if measurement type is estimate, height is not required
    if (
      property.propertyType === TreePropertyType.height &&
      measurementType?.value === "estimate"
    ) {
      return true;
    }

    // if measurement type is estimate, and size is not medium or large,
    // property_boundary is not required
    if (
      property.propertyType === TreePropertyType.property_boundary &&
      measurementType?.value === "estimate"
    ) {
      const size = treeDescriptor.properties.get(TreePropertyType.size) as
        | SizeEstimateTreePropertyDescriptor
        | undefined;

      if (size?.value && size.value !== "medium" && size.value !== "large") {
        return true;
      }
    }

    // if measurement type is detailed, and trunk type is not single or multi,
    // property_boundary is not required
    if (
      property.propertyType === TreePropertyType.property_boundary &&
      measurementType?.value === "detailed" &&
      trunkType &&
      trunkType.value !== "single" &&
      trunkType.value !== "multi"
    ) {
      return true;
    }

    // if measurement type is estimate, canopy_size is not required
    if (
      property.propertyType === TreePropertyType.canopy_size &&
      measurementType?.value === "estimate"
    ) {
      return true;
    }

    // if measurement type is detailed, and trunk type is not single or multi,
    // canopy_size is not required
    if (
      property.propertyType === TreePropertyType.canopy_size &&
      measurementType?.value === "detailed" &&
      trunkType &&
      trunkType.value !== "single" &&
      trunkType.value !== "multi"
    ) {
      return true;
    }

    // otherwise, property is valid if it has a value

    return !!property.value;
  });
}
